// STATE: No filed rates (Harris County requires a 10% premium rate for violent crimes).  
// FEDERAL: 10% of penal amount. $50.00 minimum.                                                     
// IMMIGRATION: 20% of penal amount/ $50.00 minimum.

/* eslint-disable */
export const equation = ({ bondValue, premium, type, additional }) => {
  let value = null
  let condition = null
  let minimum = 0
  if (type === 'STATE') {
    value = premium
    if (additional.county === 'HARRIS' && additional.crimeType === 'VIOLENT') {
      value = (bondValue * .1)
      minimum = (bondValue * .1)
    }
  } else if (type === 'FEDERAL') {
    value = (bondValue * .1)
    if (value < 50) {
      value = 50
      condition = 'Minimum not met'
    }
  } else if (type === 'IMMIGRATION') {
    value = (bondValue * .2)
    if (value < 50) {
      value = 50
      condition = 'Minimum not met'
    }
  }
  return { value, minimum, condition }
}
/* eslint-enable */

export default equation